import { animations, layout, colorUtils, colors } from '@prisjakt/ui-base';
import { pixelCalc } from '@prisjakt/ui-base/styles/variables';

export const compareColors = {
  highlight: colors.lightTheme.yellove500,
  separator: colors.lightTheme.yellove500,
};
export const productImageHeightDesktop = 140;
export const productImageHeightMobile = 110;
export const desktopMaxColumns = 4;
export const imageWidthVal = 140;
export const imageWidthMobileVal = 110;
export const oddColumnBackgroundColor = 'transparent';
export const evenColumnBackgroundColor = 'rgba(0, 0, 0, 0.02)';
export const dummyMaxWidth = 380;
export const mobileItemMaxWidth = '50vw';
export const tabletItemMaxWidth = '25vw';
export const productsWrapperMargin = layout.measurements.spacing050;
export const desktopItemMaxWidthVal =
  (layout.siteWidth.value - pixelCalc(productsWrapperMargin) * 2) /
  desktopMaxColumns;
export const desktopItemMaxWidth = `${desktopItemMaxWidthVal}px`;
export const itemFlex = '1 1 auto';
export const oddColumnHighlightColor = colorUtils.setRgbaAlpha(
  compareColors.highlight,
  '0.2'
);
export const evenColumnHighlightColor = colorUtils.setRgbaAlpha(
  compareColors.highlight,
  '0.25'
);

export const highlightDuration = animations.HIGHLIGHT_NEW_CONTENT_DURATION;

export const highlightNewOddColumnAnimation = animations.highlightNewContentAnimation(
  oddColumnBackgroundColor,
  oddColumnHighlightColor
);
export const highlightNewEvenColumnAnimation = animations.highlightNewContentAnimation(
  evenColumnBackgroundColor,
  oddColumnHighlightColor
);

export const features = {
  useCSSScrollSnap: true,
};
